import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiFetch } from "../../shared/api";

// redux-thunk: createAsyncThunk generates a thunk
export const fetchDashboard = createAsyncThunk(
  "dashboard/fetchDashboard",
  async ({ slug }) => {
    return await apiFetch(`/api/dashboard/dashboards/${slug}/`, { method: "GET" });
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    bySlug: {},
    statusBySlug: {},
    errorBySlug: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboard.pending, (state, action) => {
        const slug = action.meta.arg.slug;
        state.statusBySlug[slug] = "loading";
        state.errorBySlug[slug] = null;
      })
      .addCase(fetchDashboard.fulfilled, (state, action) => {
        const slug = action.meta.arg.slug;
        state.statusBySlug[slug] = "succeeded";
        state.bySlug[slug] = action.payload;
      })
      .addCase(fetchDashboard.rejected, (state, action) => {
        const slug = action.meta.arg.slug;
        state.statusBySlug[slug] = "failed";
        state.errorBySlug[slug] = action.error?.message || "Failed to load dashboard";
      });
  },
});

export const selectDashboardBySlug = (slug) => (state) => state.dashboard.bySlug[slug] || null;
export const selectDashboardStatusBySlug = (slug) => (state) =>
  state.dashboard.statusBySlug[slug] || "idle";
export const selectDashboardErrorBySlug = (slug) => (state) => state.dashboard.errorBySlug[slug] || null;

export default dashboardSlice.reducer;


